import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useAdAccountSettings(userId: string, adAccountId: string) {
  return useQuery({
    queryKey: ["ad-account-settings", userId, adAccountId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("ad_account_settings")
        .select("*")
        .eq("user_id", userId)
        .eq("ad_account_id", adAccountId)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!userId && !!adAccountId,
    staleTime: 5 * 60 * 1000,
  });
}
